import React from 'react';
import cx from 'classnames';
import Toggle from 'react-toggle';
import { useSelector, useDispatch } from 'react-redux';
import { getWeddingAccount } from 'selectors/website/websiteSelectors';
import { updateWeddingAccount } from 'actions/WeddingActions';
import sharedStyles from '../../../EditPageCommon/editPageSharedStyles.module.less';

const MonogramFooter = () => {
  const account = useSelector(getWeddingAccount);
  const dispatch = useDispatch();

  const onToggle = () => {
    const accountUpdate = Object.assign({}, account, { enable_seal: !account.enable_seal });
    dispatch(updateWeddingAccount(accountUpdate));
  };
  return (
    <>
      <div className="form-group enable-seal visible-xs visible-sm">
        <label className={cx('toggle-description', sharedStyles.label)}>
          Monogram Footer
          <div
            className="with-tooltip"
            data-tooltip="A few of our website designs include a monogram at the base of the website pages. If your selected design has this detail, you can choose to make it visible or hidden here."
          >
            <i className="zolaicon zolaicon-info" />
          </div>
        </label>
        <Toggle
          checked={account.enable_seal}
          onChange={onToggle}
          icons={{
            checked: <span className="toggle-label checked">Visible</span>,
            unchecked: <span className="toggle-label unchecked">Hidden</span>,
          }}
        />
      </div>
      <div className="form-group enable-seal visible-md visible-lg">
        <span className="toggle-description form-label">
          <div
            className="with-tooltip"
            data-tooltip="A few of our website designs include a monogram at the base of the website pages. If your selected design has this detail, you can choose to make it visible or hidden here."
          >
            <label className={cx('monogram', sharedStyles.label)}>Monogram Footer</label>
            <Toggle
              checked={account.enable_seal}
              onChange={onToggle}
              icons={{
                checked: <span className="toggle-label checked monogram-toggle">Visible</span>,
                unchecked: <span className="toggle-label unchecked monogram-toggle">Hidden</span>,
              }}
            />
          </div>
        </span>
      </div>
    </>
  );
};

export default MonogramFooter;
